import React, { useState, useEffect } from 'react';
import { Badge, Card, Col, Pagination, Row, Table, Form, Spinner, Button } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faFilePdf, faTrash } from '@fortawesome/free-solid-svg-icons';

import { useTranslation } from "react-i18next";
const PickDateCell = ({ claim, pickedDates, setPickedDates }) => {
    const { t } = useTranslation();
    return (
        <td>
            {claim.status === "Waiting for Admin Action" ? (
                <Form.Control
                    type="date"
                    max={new Date().toISOString().split("T")[0]} // restrict to today
                    value={pickedDates[claim._id] || ""}
                    onChange={(e) => {
                        if (!claim?._id) return;
                        const value = e.target.value; // value is the picked date (YYYY-MM-DD)
                        setPickedDates(prev => ({
                            ...prev,
                            [claim._id]: value
                        }));

                        // Optional: send immediately to backend
                        // sendPickDateToBackend(claim._id, value);
                    }}
                    size="sm"
                />

            ) : (
                <Form.Control
                    type="text"
                    value={`Delay: ${claim.NoOfDays} days`}
                    size="sm"
                    disabled
                    style={{ minWidth: "120px" }}
                />

            )}


        </td>
    );
};

export default PickDateCell;
